"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// eslint-disable-next-line import/no-cycle
const types_1 = require("~/store/types");
const three_1 = require("three");
// eslint-disable-next-line import/no-cycle
const ComponentObjectsBase_3d_1 = __importDefault(require("../classes/ComponentObjectsBase.3d"));
// eslint-disable-next-line import/no-cycle
const utils_3d_1 = require("../utils/utils.3d");
const tempVector = new three_1.Vector3();
class Component extends ComponentObjectsBase_3d_1.default {
    constructor(alignInfo) {
        super();
        if (alignInfo) {
            this.alignGeomInfo = alignInfo;
        }
        else {
            this.planePoint = new three_1.Vector3(1, 1, 0);
            this.axis = [new three_1.Vector3(0, 0, 0), new three_1.Vector3(0, 1, 0)];
        }
        this.type = 'Component';
    }
    /**
     * Get a matrix that contains the basis of the fastener object where:
     * - X direction is the fastener's normal direction.
     * - Y direction is the alignment axis of the fastener (if any) or
     * any vector perpendicular to the normal direction.
     * - Z direction is the cross product of the above vectors.
     */
    getBasisMatrix() {
        var _a;
        const xDirection = this.directionNormal;
        const yDirection = (_a = this.getAlignmentAxis()) !== null && _a !== void 0 ? _a : (0, utils_3d_1.invertVector)(xDirection);
        const zDirection = tempVector.copy(xDirection).cross(yDirection);
        return new three_1.Matrix4().makeBasis(xDirection, yDirection, zDirection);
    }
    alignToDirection(dir, orthogonalToDir, tempCompAxis, isNegAngle = false) {
        let angle = tempCompAxis.angleTo(dir);
        if ((0, utils_3d_1.areEqual)(angle, 0)) {
            return;
        }
        if (isNegAngle) {
            angle = -angle;
        }
        if ((0, utils_3d_1.areEqual)(angle, Math.PI)) {
            this.rotateOnAxis(orthogonalToDir, Math.PI);
        }
        else {
            const cross = new three_1.Vector3();
            cross.crossVectors(tempCompAxis, dir);
            this.rotateOnAxis(cross, angle);
        }
    }
    rotateAlignByExtrusionAxis(componentNormal, faceNormal, extrusionAxis, neighborIsVertical) {
        const pt1 = this.axis[0];
        const pt2 = this.axis[1];
        const compAxis = new three_1.Vector3(pt1.x - pt2.x, pt1.y - pt2.y, pt1.z - pt2.z);
        const faceNormalNeg = faceNormal.clone();
        faceNormalNeg.negate();
        let isNegAngle = false;
        if (!neighborIsVertical) {
            this.alignToDirection(faceNormal, extrusionAxis, componentNormal, isNegAngle);
        }
        else {
            this.alignToDirection(faceNormalNeg, extrusionAxis, compAxis, isNegAngle);
            if (componentNormal.dot(extrusionAxis) !== 1) {
                isNegAngle = true;
            }
        }
        if (compAxis.dot(extrusionAxis) !== -1) {
            this.alignToDirection(extrusionAxis, extrusionAxis, compAxis, isNegAngle);
        }
    }
    checkIfAllVisualizationDataPresent() {
        if (this.partDetails.componentType === types_1.COMPONENT_TYPE.PANEL_GASKET) {
            // TODO: Implement checking of panel gaskets after the visualization of this group is added
        }
        return true;
    }
}
exports.default = Component;
